module.exports = __webpack_public_path__ + "public/images/schedule/schedule-cuba.2748c58f3ce7fc716b910d3a7806f508.jpeg";